import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from '@modules/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

import { UsersListComponent, AddUsersComponent } from './presentation/pages';
import { AdminUsersRoutingModule } from './presentation/admin-users-routing.module';
import { UserDetailsComponent } from './presentation/pages/user-details/user-details.component';
import { NgxPaginationModule } from 'ngx-pagination';
import {
  UsersStoreModule,
  UsersEffectsModule,
} from './application/store/users-store';
import { UsersServices } from './domain/services/users.service';
import { UsersServicesImpl } from './infrastructure/services/users.service.impl';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import {
  ClientsEffectsModule,
  ClientsStoreModule,
} from '../clients/application/store/clients-store';
import { ClientsServices } from '../clients/domain/services/clients.service';
import { ClientsServicesImpl } from '../clients/infrastructure/services/clients.service.impl';

export * from './application';
export * from './domain';

export * from './infrastructure';
export * from './presentation';

@NgModule({
  declarations: [UsersListComponent, AddUsersComponent, UserDetailsComponent],
  providers: [
    {
      provide: UsersServices,
      useClass: UsersServicesImpl,
    },
    {
      provide: ClientsServices,
      useClass: ClientsServicesImpl,
    },
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatMenuModule,
    ReactiveFormsModule,
    AdminUsersRoutingModule,
    SharedModule,
    NgxPaginationModule,
    UsersStoreModule,
    UsersEffectsModule,
    ClientsStoreModule,
    ClientsEffectsModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
})
export class AdminUsersModule {}
